import { LuckyNumberRadioGroup } from 'common-components'

const Component = ({ onClick, ...props }) => <LuckyNumberRadioGroup setValue={onClick} {...props} />

function EncComponent(props) {
  const { setValue, customOnClick, value } = props
  const _value = _.get(value, 'id')
  const onClick = (option) => {
    console.log('onClick :', option)
    if (customOnClick) {
      customOnClick(option)
    }

    setValue(option)
  }

  return <Component {...props} onClick={onClick} value={_value} />
}

export default (hoc) => EncComponent
